import { assignTeamLead } from './assignTeamLead';
import { createOperator } from './createOperator';
import { deleteOperator } from './deleteOperator';
import { downloadOperatorActivityReports } from './downloadOperatorActivityReports';
import { extractCallMotivationAndObjection } from './extractCallMotivationAndObjection';
import { fetchOperator } from './fetchOperator';
import { fetchOperatorOptions } from './fetchOperatorOptions';
import { fetchOperators } from './fetchOperators';
import { fetchSupervisors } from './fetchSupervisors';
import { fetchSupervisorsWithStatus } from './fetchSupervisorsWithStatus';
import { fetchTeamLeadByOperator } from './fetchTeamLeadByOperator';
import { fetchTeamLeadOperatorActivitiesSummary } from './fetchTeamLeadOperatorActivitiesSummary';
import { fetchTeamLeads } from './fetchTeamLeads';
import { fetchOperatorActivitiesSummary } from './fetchOperatorActivitiesSummary';
import { fetchOperatorWeeklyScores } from './fetchOperatorWeeklyScores';
import { generateOperatorPerformanceSummary } from './generateOperatorPerformanceSummary';
import { masterCallSummary } from './masterCallSummary';
import { generateCallAvoidanceAnalysis } from './generateCallAvoidanceAnalysis';
import { getLossPreventionAlerts } from './getLossPreventionAlerts';
import { operatorSignInOut } from './operatorSignInOut';
import { putOperatorOffline } from './putOperatorOffline';
import { stopOperatorSuspension } from './stopOperatorSuspension';
import { suspendOperator } from './suspendOperator';
import { unassignTeamLead } from './unassignTeamLead';
import { updateOperator } from './updateOperator';
import { updateOperatorActivity } from './updateOperatorActivity';
import { updateOperatorSignInOutReason } from './updateOperatorSignInOutReason';

export const operatorService = {
  assignTeamLead,
  createOperator,
  deleteOperator,
  downloadOperatorActivityReports,
  extractCallMotivationAndObjection,
  fetchOperator,
  fetchOperatorOptions,
  fetchOperators,
  fetchSupervisors,
  fetchSupervisorsWithStatus,
  fetchTeamLeadByOperator,
  fetchTeamLeadOperatorActivitiesSummary,
  fetchTeamLeads,
  fetchOperatorActivitiesSummary,
  fetchOperatorWeeklyScores,
  generateOperatorPerformanceSummary,
  masterCallSummary,
  generateCallAvoidanceAnalysis,
  getLossPreventionAlerts,
  operatorSignInOut,
  putOperatorOffline,
  stopOperatorSuspension,
  suspendOperator,
  unassignTeamLead,
  updateOperator,
  updateOperatorActivity,
  updateOperatorSignInOutReason,
};
